import { flowState } from '../../pages/AddPrize/AddPrizePage';
import { Box, Typography } from '@mui/material';
import { TooltipText } from "../../components/inputComponents/TooltipText";
import { RadioButton } from "../../components/inputComponents/RadioButton";
import { AllocateDates } from '../../components/selectComponents/AllocateDates';
import { PrizeTeaser } from './PrizeTeaser';
import { useState } from 'react';

interface PrizeStateProps {
  configurationData: any;
  isEdit?: boolean;
    timelineLocked?: boolean;
}

function PrizeState({ formik, configurationData, isEdit = false, timelineLocked = false}: flowState & PrizeStateProps) {
    const [prevState, setPrevState] = useState<string | null>(null);
    const [hasOptionChanged, setHasOptionChanged] = useState<boolean>(false);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const stateChanged = prevState !== value;
        setPrevState(value);
        if (stateChanged) {
            setHasOptionChanged(prev => !prev);
        }
        formik.handleChange(event);
    };

    const tempParams = formik.values.tempParams;

    return (
        <Box className='prize-state-box'>
            <Typography variant='h4' gutterBottom>Timeline</Typography>
            <TooltipText text='Define when the prize is available for distribution. You can align the prize timeline with the promotion period or set a different availability window'
             textVariant='body1'
             tooltip="Prize start and end dates are optional and independent from the promotion timeline. Use a custom prize timeline if the prize should be available only during part of the promotion. If no dates are set, the prize will follow the promotion duration." />
            <Box className='radio-group-form'>
                <RadioButton formik={formik} values={[
                    { value: 'active', label: 'Same as promotion duration'},
                    {
                        value: 'custom', label: 'Custom prize timeline', useComponent: true,
                        component:
                        <>
                            <AllocateDates
                              description={'Date Range'} datetime={true}
                              isUpdatePrizeState={isEdit} isNewPrizeState={!isEdit}
                              formikStartDate={`tempParams.start_date`} formikEndDate={`tempParams.end_date`} formikTimezoneValue={'prize_activity_timezone'}
                              minStartDate={isEdit && tempParams.prizeStatus === 'custom' ? Date.now() : tempParams.promoStart}
                              maxEndDate={tempParams.promoEnd}
                              disabled={timelineLocked}
                            />
                            <PrizeTeaser label='Prize Teaser' hasPrizeOptionChanged={hasOptionChanged} disabled={timelineLocked} />
                        </>
                    }
                ]}
                    radioGroupName={'tempParams.prizeStatus'}
                    disabled={timelineLocked}
                    customAction={handleRadioChange}
                />
                {timelineLocked && (
                    <Typography variant='body2' sx={{ marginTop: 1 }}>
                        Timeline cannot be edited after promotion start because this prize already has associated winning moments.
                    </Typography>
                )}

            </Box>
        </Box>
    )
}

export { PrizeState }
